// /frontend/src/pages/WarrantyPage.jsx
import React from 'react';
import Layout from '../components/layout/Layout';

const WarrantyPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Warranty Information</h1>
        
        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Our Commitment to Quality</h2>
          <p className="mb-6">
            At Henderson Design Group, we stand behind the quality of our products. We carefully select our furniture and decor items from trusted manufacturers who share our commitment to excellence.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Manufacturer's Warranty</h2>
          <p className="mb-6">
            All products sold by Henderson Design Group are covered by their respective manufacturer's warranty. Warranty periods vary by manufacturer and product category, generally ranging from 1 to 5 years from the date of delivery.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">What's Covered</h2>
          <p className="mb-4">
            Typical coverage includes:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Manufacturing defects in materials and workmanship</li>
            <li className="mb-2">Structural integrity issues</li>
            <li className="mb-2">Premature wear under normal use</li>
            <li className="mb-2">Mechanical failures for items with moving parts</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">What's Not Covered</h2>
          <p className="mb-4">
            The following are typically not covered by warranty:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Normal wear and tear</li>
            <li className="mb-2">Damage resulting from improper use or care</li>
            <li className="mb-2">Damage from environmental conditions (sunlight fading, moisture damage)</li>
            <li className="mb-2">Changes in wood finish due to aging or exposure to light</li>
            <li className="mb-2">Damage during self-transport or improper installation</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Making a Warranty Claim</h2>
          <p className="mb-4">
            If you believe your product has a defect covered under warranty:
          </p>
          <ol className="list-decimal pl-6 mb-6">
            <li className="mb-2">Contact our customer service team at <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a></li>
            <li className="mb-2">Provide your order number and detailed description of the issue</li>
            <li className="mb-2">Include photos clearly showing the defect</li>
            <li className="mb-2">Our team will evaluate your claim and guide you through the warranty process</li>
          </ol>
          
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-10">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Need assistance with a warranty claim?</h3>
            <p className="mb-4">
              Our team is here to help. Contact us at <a href="tel:+18083158782" className="text-teal-700 hover:text-teal-900">808.315.8782</a> or <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a>.
            </p>
            <p className="text-sm text-gray-500">
              Please note: We require 3 months lead time for all installations.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WarrantyPage;